import { render, staticRenderFns } from "./MaintenanceSplash.vue?vue&type=template&id=8711f116&scoped=true"
import script from "./MaintenanceSplash.vue?vue&type=script&lang=js"
export * from "./MaintenanceSplash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8711f116",
  null
  
)

export default component.exports